import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getPromo} from '../api/in-store-promotion.api';
import {getStoreInformation} from '../core/localstorage-data';
import type {RootState} from './store';

interface promoResponse {
    content :{
        [key: string]: string
    
      };
      images:{
    
        [key: string]: string
      };
}

interface promoState {
  promotion: promoResponse;
  loading: boolean;
  error: string;
}

const initialState: promoState = {
  promotion: {
    content: {},
    images:{}
  },
  loading: false,
  error: '',
};

export const fetchPromo = createAsyncThunk(
  'getPromo/fetchPromo',
  async (payload: undefined, thunkApi) => {
  
    const storeInfomation = getStoreInformation();
    if(storeInfomation?.store_code!== undefined)
    {
      const storeId = storeInfomation?.store_code;
    
      return getPromo(storeId)
        .then(response => {
          return response;
        })
        
        .catch(error => {
          return thunkApi.rejectWithValue(error.response.data);
        });
    }
   
  },
);

export const promoSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPromo.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchPromo.fulfilled, (state, {payload}) => {
      state.loading = false;
      state.promotion = payload;
      //console.log(payload);
    });
    builder.addCase(fetchPromo.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

export const error = (state: RootState): string => state.promoReducer.error;
export const loading = (state: RootState): boolean => state.promoReducer.loading;
export const promoResponse = (state: RootState): promoResponse =>
  state.promoReducer.promotion;

export default promoSlice.reducer;
